<app-lista-arquivos [categoria]="categoria" [miniMode]="true" [modo]="'trofeu'" [linhas]="10"  [acao]="acao" ></app-lista-arquivos>